
import * as Data from "@/../src-gen/data";
import FBtnMDP from "@/components/FBtnMDP";
import FFormSubmitBtnMDP from "@/components/FFormSubmitBtnMDP";
import FFormMDP, { FFormChildMDP } from "@/components/form/FFormMDP";
import FAWSCRUploadFileFieldMDP from "@/components/form/field/FAWSCRUploadFileFieldMDP";
import FPasswordFieldMDP from "@/components/form/field/FPasswordFieldMDP";
import FSelectFieldMDP from "@/components/form/field/FSelectFieldMDP";

export default class FUpdateCreditScoreFFormMDP extends FFormMDP {
    childMDP = new FFormChildMDP();
    taskRoot: any;
    parent: any;
    constructor({ parent }: {  parent: any }) {
        super({ myRefName: "fUpdateCreditScoreFFormRef" });
        this.parent = parent;
        this.addField(new FAWSCRUploadFileFieldMDP({
            parentMDP: this.childMDP,
            dataSelectorKey: "filename",
            label: "Credit Report",
            boundaryClass: "col-4",
            mandatory: true,
        }))
        .addField(new FSelectFieldMDP({
            dataSelectorKey: "creditBureau",
            label: "Credit Bureau",
            options: Data.Spine.CREDIT_BUREAU.list(),
            parentMDP: this.childMDP,
            // returnObject: true,
            optionLabel: "name",
            optionValue: "id",
            boundaryClass: "col-4",
            mandatory: true
        }))
        .addField(new FPasswordFieldMDP({
            label:"Password",
            dataSelectorKey: "password",
            parentMDP: this.childMDP,
            boundaryClass: "col-4",
        }))
        .addAction(new FBtnMDP({
            label: "Cancel",
            onClick: () => this.parent.closeAndClearAllForms(),
        })).addAction(new FFormSubmitBtnMDP({
            label: "Uplaod Credit Report",
            onClick: () => this.parent.addCreditorFromPDF()
        }))
    }

 

    getMyRef() {
        return this.parent.$refs[this.myRefName];
    }
}